module.exports = __webpack_public_path__ + "assets/img/title.5559930d.png";